// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.register-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 480px;
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-logo {
  width: 100px;
  height: auto;
  margin-bottom: 15px;
}

.register-header h1 {
  color: #333;
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 5px 0;
}

.register-header p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.register-form {
  margin-bottom: 24px;
}

.form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group.half-width {
  flex: 1 1;
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #333;
  font-weight: 600;
  font-size: 14px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group input:disabled,
.form-group select:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
}

.password-input {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.password-toggle:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.field-error {
  display: block;
  color: #e74c3c;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
}

.error-message {
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #c33;
}

.success-message {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #155724;
}

.error-icon,
.success-icon {
  margin-right: 8px;
  font-size: 16px;
}

.register-button {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.register-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.register-button:active:not(:disabled) {
  transform: translateY(0);
}

.register-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.register-footer {
  text-align: center;
  margin-top: 20px;
}

.register-footer p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.link-button {
  background: none;
  border: none;
  color: #667eea;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.link-button:hover:not(:disabled) {
  color: #5a6fd8;
}

.link-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive design */
@media (max-width: 600px) {
  .register-card {
    padding: 30px 20px;
    margin: 10px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-group.half-width {
    margin-bottom: 20px;
  }
  
  .register-header h1 {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Register.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".register-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n}\n\n.register-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  width: 100%;\n  max-width: 480px;\n  animation: slideIn 0.5s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.register-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.register-logo {\n  width: 100px;\n  height: auto;\n  margin-bottom: 15px;\n}\n\n.register-header h1 {\n  color: #333;\n  font-size: 26px;\n  font-weight: 700;\n  margin: 0 0 5px 0;\n}\n\n.register-header p {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.register-form {\n  margin-bottom: 24px;\n}\n\n.form-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group.half-width {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  color: #333;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e1e5e9;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group input:disabled,\n.form-group select:disabled {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n}\n\n.password-input {\n  position: relative;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.password-toggle:hover:not(:disabled) {\n  background-color: #f0f0f0;\n}\n\n.password-toggle:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.field-error {\n  display: block;\n  color: #e74c3c;\n  font-size: 12px;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n.error-message {\n  background-color: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #c33;\n}\n\n.success-message {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #155724;\n}\n\n.error-icon,\n.success-icon {\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.register-button {\n  width: 100%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 14px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.register-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);\n}\n\n.register-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.register-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.register-footer {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.register-footer p {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  color: #667eea;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.link-button:hover:not(:disabled) {\n  color: #5a6fd8;\n}\n\n.link-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .register-card {\n    padding: 30px 20px;\n    margin: 10px;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .form-group.half-width {\n    margin-bottom: 20px;\n  }\n  \n  .register-header h1 {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
